import { useMemo } from "react";
import { theme } from "antd";
import { deepMergeTokens } from "@utils/themeUtils";
import { ConsumerTokens, EnigmaTokens } from "@type/tokens";
import { baseTokens, internalTokens } from "@constants/tokens";
import { useConsumerToken } from "./useConsumerToken";

const { useToken: useAntdToken } = theme;

const TOKENS = new Map<string, ConsumerTokens>();

export const useEnigmaToken = (): EnigmaTokens => {
    const { token: antdToken } = useAntdToken();
    const consumerTokens = useConsumerToken();

    return useMemo(
        () =>
            deepMergeTokens<EnigmaTokens>(
                {},
                antdToken,
                consumerTokens,
                internalTokens
            ),
        [consumerTokens]
    );
};

useEnigmaToken.getDesignToken = (providerId = "default"): EnigmaTokens =>
    deepMergeTokens<EnigmaTokens>(
        {},
        theme.getDesignToken(),
        TOKENS.get(providerId) || baseTokens,
        internalTokens
    );

useEnigmaToken.setDesignToken = (
    tokens: ConsumerTokens,
    providerId = "default"
) => {
    TOKENS.set(providerId, tokens);
};
